import React, { useEffect, useState } from "react";
import axios from "axios";
import PaginatedTable from "../components/library/Pagination";
import Loader from "../components/common/Loader";
import API_BASE_URL from "../config/api";

const API_BASE = `${API_BASE_URL}/api/company`;

const Avatar = ({ url, name, size = 56 }) => (
    <div
        className="rounded-full bg-center bg-cover overflow-hidden inline-block"
        style={{ width: size, height: size, backgroundImage: `url(${url})` }}
        title={name}
    />
);

export default function CompanyDetails() {
    const [activeTab, setActiveTab] = useState("organization");
    const [orgNodes, setOrgNodes] = useState([]); // hierarchical list/top roles
    const [departments, setDepartments] = useState([]);
    const [directory, setDirectory] = useState([]);
    const [selectedDept, setSelectedDept] = useState("");
    const [loading, setLoading] = useState(false);

    const token = sessionStorage.getItem("token");

    useEffect(() => {
        setLoading(true);
        fetchOrganization();
        fetchDepartments();
        fetchDirectory();
        setLoading(false);
    }, []);

    const fetchOrganization = async () => {
        try {

            const res = await axios.get(`${API_BASE}/organization`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setOrgNodes(res.data);
        } catch (err) {
            console.error("fetchOrganization:", err);
        }
    };

    const fetchDepartments = async () => {
        try {
            const res = await axios.get(`${API_BASE}/departments`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setDepartments(res.data);
        } catch (err) {
            console.error("fetchDepartments:", err);
        }
    };

    const fetchDirectory = async (departmentId = "") => {
        try {
            const url = departmentId
                ? `${API_BASE}/directory?departmentId=${departmentId}`
                : `${API_BASE}/directory`;
            const res = await axios.get(url, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setDirectory(res.data);
        } catch (err) {
            console.error("fetchDirectory:", err);
        }
    };

    const onDeptChange = (e) => {
        const val = e.target.value;
        setSelectedDept(val);
        // fetchDirectory(val);
    };

    return (
        <>
            {loading ? (
                <Loader message="Loading..." />
            ) : (
                <div className="relative flex min-h-screen flex-col bg-white group/design-root overflow-x-hidden">
                    <div className="layout-container flex h-full grow flex-col">
                        <div className="flex flex-1 justify-center py-5">
                            <div className="layout-content-container flex flex-col mx-auto flex-1">
                                {/* <div className="flex flex-wrap gap-2 pb-2">
                                    <a className="text-[#677883] text-base font-medium" href="/app/payroll">
                                        Payroll
                                    </a>
                                    <span className="text-[#677883] text-base font-medium">/</span>
                                    <span className="text-[#121517] text-base font-medium">Company</span>
                                </div> */}

                                <div className="flex flex-wrap justify-between gap-3">
                                    <p className="text-[#121516] tracking-light text-[32px] font-bold leading-tight min-w-72">
                                        Company
                                    </p>
                                </div> 

                                {/* Tabs */}
                                <div className="pb-3">
                                    <div className="flex border-b border-[#dde1e3] px-4 gap-8">
                                        <button
                                            onClick={() => setActiveTab("organization")}
                                            className={`flex flex-col items-center justify-center pb-[13px] pt-4 ${activeTab === "organization"
                                                ? "border-b-[3px] border-b-[#121516] text-[#121516]"
                                                : "border-b-[3px] border-b-transparent text-[#6a7881]"
                                                }`}
                                        >
                                            <p className="text-sm font-bold">Organization</p>
                                        </button>

                                        {/* <button
                                onClick={() => setActiveTab("departments")}
                                className={`flex flex-col items-center justify-center pb-[13px] pt-4 ${activeTab === "departments"
                                    ? "border-b-[3px] border-b-[#121516] text-[#121516]"
                                    : "border-b-[3px] border-b-transparent text-[#6a7881]"
                                    }`}
                            >
                                <p className="text-sm font-bold">Departments</p>
                            </button> */}
                                    </div>
                                </div>

                                {/* Organization Tab */}
                                {activeTab === "organization" && (
                                    <>
                                        <h2 className="text-[#121516] text-[22px] font-bold px-4 pb-3 pt-5">
                                            Organization chart
                                        </h2>

                                        <div className="grid grid-cols-[repeat(auto-fit,minmax(158px,1fr))] gap-3 p-4">
                                            {loading ? (
                                                <div className="col-span-full text-center py-10">Loading...</div>
                                            ) : orgNodes.length === 0 ? (
                                                <div className="col-span-full text-center py-10">
                                                    No organization data
                                                </div>
                                            ) : (
                                                orgNodes.map((node) => (
                                                    <div
                                                        key={node.id}
                                                        className="flex flex-col gap-3 text-center pb-3"
                                                    >
                                                        <div className="px-4">
                                                            <Avatar
                                                                url={
                                                                    node.profileImageUrl
                                                                        ? `${API_BASE_URL}/uploads/${node.profileImageUrl}`
                                                                        : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"
                                                                }
                                                                name={node.name}
                                                                size={96}
                                                            />
                                                        </div>
                                                        <div>
                                                            <p className="text-[#121516] text-base font-medium leading-normal">
                                                                {node.title}
                                                            </p>
                                                            <p className="text-[#6a7881] text-sm font-normal leading-normal">
                                                                {node.name}
                                                            </p>
                                                        </div>
                                                    </div>
                                                ))
                                            )}
                                        </div>

                                        <h2 className="text-[#121516] text-[22px] font-bold px-4 pb-3 pt-5">
                                            Company directory
                                        </h2>

                                        <div className="px-4 py-3 @container">
                                            <div className="flex overflow-hidden rounded-xl border border-[#dde1e3] bg-white">

                                                <PaginatedTable
                                                    columns={["Profile", "ID", "Name", "Title", "Joining date"]}
                                                    data={directory}
                                                    pageSize={10}
                                                    renderRow={(emp, index) => (
                                                        <tr
                                                            key={emp.id}
                                                            className="border-t border-t-[#dde1e3] hover:bg-[#fbfcfd]"
                                                        >
                                                            <td className="px-4 py-3">
                                                                <div className="flex items-center gap-3">
                                                                    <div
                                                                        style={{ width: 40, height: 40 }}
                                                                        className="rounded-full overflow-hidden bg-cover bg-center"
                                                                        title={emp.name}
                                                                    >
                                                                        <img
                                                                            src={
                                                                                emp.profileImageUrl
                                                                                    ? `${API_BASE_URL}/uploads/${emp.profileImageUrl}`
                                                                                    : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"
                                                                            }
                                                                            alt={emp.name}
                                                                            className="w-full h-full object-cover"
                                                                        />
                                                                    </div>
                                                                </div>
                                                            </td>
                                                            <td className="px-4 py-3 text-sm text-[#6a7881]">
                                                                {emp.employeeCode || emp.id}
                                                            </td>
                                                            <td className="px-4 py-3 text-sm text-[#121516]">
                                                                {emp.name}
                                                            </td>
                                                            <td className="px-4 py-3 text-sm text-[#6a7881]">
                                                                {emp.title}
                                                            </td>
                                                            {/* <td className="px-4 py-3 text-sm text-[#6a7881]">
                                                    {emp.departmentName}
                                                </td> */}
                                                            <td className="px-4 py-3 text-sm text-[#6a7881]">
                                                                {emp.joinDate
                                                                    ? new Date(emp.joinDate).toLocaleDateString()
                                                                    : ""}
                                                            </td>
                                                        </tr>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}

                                {/* Departments Tab */}
                                {activeTab === "departments" && (
                                    <>
                                        <h2 className="text-[#121516] text-[22px] font-bold px-4 pb-3 pt-5">
                                            Departments
                                        </h2>

                                        <div className="p-4 grid grid-cols-1 md:grid-cols-3 gap-4">
                                            {departments.length === 0 ? (
                                                <div className="col-span-full text-center py-6">
                                                    No departments
                                                </div>
                                            ) : (
                                                departments.map((d) => (
                                                    <div key={d.id} className="border rounded-lg p-4">
                                                        <p className="text-[#121516] font-bold">{d.name}</p>
                                                        <p className="text-[#6a7881] text-sm mt-1">
                                                            {d.description || "—"}
                                                        </p>
                                                        <p className="text-sm mt-2 text-[#6a7881]">
                                                            {d.headName ? `Head: ${d.headName}` : ""}
                                                        </p>
                                                    </div>
                                                ))
                                            )}
                                        </div>

                                        <div className="px-4 pt-4">
                                            <label className="block mb-2 text-sm text-[#111518]">
                                                Filter Directory by Department
                                            </label>
                                            <div className="flex gap-3 items-center">
                                                <select
                                                    value={selectedDept}
                                                    onChange={onDeptChange}
                                                    className="border rounded-xl h-12 px-3"
                                                >
                                                    <option value="">All departments</option>
                                                    {departments.map((d) => (
                                                        <option key={d.id} value={d.id}>
                                                            {d.name}
                                                        </option>
                                                    ))}
                                                </select>
                                                <button
                                                    className="btn-black"
                                                    onClick={() => fetchDirectory(selectedDept)}
                                                >
                                                    Apply
                                                </button>
                                            </div>
                                        </div>

                                        <div className="px-4 py-3 @container">
                                            <div className="flex overflow-hidden rounded-xl border border-[#dde1e3] bg-white mt-4">

                                                <PaginatedTable
                                                    columns={["Profile", "ID", "Name", "Title", "Department", "Joining date"]}
                                                    data={directory}
                                                    pageSize={10}
                                                    renderRow={(emp, index) => (
                                                        <tr
                                                            key={emp.id}
                                                            className="border-t border-t-[#dde1e3] hover:bg-[#fbfcfd]"
                                                        >
                                                            <td className="px-4 py-3">
                                                                <div
                                                                    style={{ width: 40, height: 40 }}
                                                                    className="rounded-full overflow-hidden bg-cover bg-center"
                                                                >
                                                                    <img
                                                                        src={
                                                                            emp.profileImageUrl
                                                                                ? `${API_BASE_URL}/uploads/${emp.profileImageUrl}`
                                                                                : "https://cdn.pixabay.com/photo/2015/10/05/22/37/blank-profile-picture-973460_960_720.png"
                                                                        }
                                                                        alt={emp.name}
                                                                        className="w-full h-full object-cover"
                                                                    />
                                                                </div>

                                                            </td>
                                                            <td className="px-4 py-3 text-sm text-[#6a7881]">
                                                                {emp.employeeCode || emp.id}
                                                            </td>
                                                            <td className="px-4 py-3 text-sm text-[#121516]">
                                                                {emp.name}
                                                            </td>
                                                            <td className="px-4 py-3 text-sm text-[#6a7881]">
                                                                {emp.title}
                                                            </td>
                                                            <td className="px-4 py-3 text-sm text-[#6a7881]">
                                                                {emp.departmentName}
                                                            </td>
                                                            <td className="px-4 py-3 text-sm text-[#6a7881]">
                                                                {emp.joinDate
                                                                    ? new Date(emp.joinDate).toLocaleDateString()
                                                                    : ""}
                                                            </td>
                                                        </tr>
                                                    )}
                                                />
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    );
}